import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=e206a4d4&scoped=true&"
import script from "./ServiceSection.vue?vue&type=script&lang=js&"
export * from "./ServiceSection.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=e206a4d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e206a4d4",
  null
  
)

export default component.exports